import { useLocation } from "react-router-dom";
import SEO from "@/components/SEO";

export default function NotFound() {
  const location = useLocation();
  const path = location.pathname;

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center px-4">
      <SEO
        meta={{
          title: "找不到此頁面｜美好時光指南",
          description: "你輸入的網址不存在，可能已經被移除或網址有誤。",
          noindex: true,
        }}
      />
      <div className="w-20 h-20 flex items-center justify-center rounded-full bg-slate-100 mb-6">
        <i className="ri-file-search-line text-3xl text-slate-400" />
      </div>
      <h1 className="text-3xl md:text-4xl font-bold text-slate-800 mb-3">
        找不到此頁面
      </h1>
      <p className="text-sm text-slate-400 font-mono mb-4">
        {path}
      </p>
      <p className="text-base text-slate-500 mb-8 max-w-md text-center">
        你輸入的網址不存在，可能已經被移除或網址有誤。
      </p>
      <div className="flex items-center gap-3">
        <a
          href="/"
          className="px-5 py-2.5 bg-primary text-white text-sm font-medium rounded-full hover:bg-primary-dark transition-colors whitespace-nowrap"
        >
          返回首頁
        </a>
        <a
          href="/articles"
          className="px-5 py-2.5 bg-white text-slate-700 text-sm font-medium rounded-full border border-slate-200 hover:bg-slate-50 transition-colors whitespace-nowrap"
        >
          瀏覽文章
        </a>
      </div>
    </div>
  );
}